export const CHANGE_SCHEDULING_TYPE =
  'app/TextMessaging/TextMessagesSettings/CHANGE_SCHEDULING_TYPE';

export const CHANGE_SCHEDULING_VALUE =
  'app/TextMessaging/TextMessagesSettings/CHANGE_SCHEDULING_VALUE';

export const CHANGE_SCHEDULING_VARIABLE =
  'app/TextMessaging/TextMessagesSettings/CHANGE_SCHEDULING_VARIABLE';

export const CHANGE_SCHEDULING_FREQUENCY =
  'app/TextMessaging/TextMessagesSettings/CHANGE_SCHEDULING_FREQUENCY';

export const CHANGE_FORMULA_VALUE =
  'app/TextMessaging/TextMessagesSettings/CHANGE_FORMULA_VALUE';

export const CHANGE_TILE_NAME =
  'app/TextMessaging/TextMessagesSettings/CHANGE_TILE_NAME';

export const CHANGE_FORMULA_USED =
  'app/TextMessaging/TextMessagesSettings/CHANGE_FORMULA_USED';

export const CHANGE_NO_FORMULA_TEXT =
  'app/TextMessaging/TextMessagesSettings/CHANGE_NO_FORMULA_TEXT';

export const CHANGE_TYPE = 'app/TextMessaging/TextMessagesSettings/CHANGE_TYPE';

export const CHANGE_INCLUDED_DATA =
  'app/TextMessaging/TextMessagesSettings/CHANGE_INCLUDED_DATA';

export const CHANGE_SMS_SEND_TIME_TYPE =
  'app/TextMessaging/TextMessagesSettings/CHANGE_SMS_SEND_TIME_TYPE';

export const CHANGE_SMS_SEND_TIME_DETAILS =
  'app/TextMessaging/TextMessagesSettings/CHANGE_SMS_SEND_TIME_DETAILS';
